import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "row list-unstyled mx-auto p-inline-start-0" }
const _hoisted_3 = {
  key: 0,
  class: "col-12"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-datei_word mr-2",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_6 = { class: "title title-with-icon" }
const _hoisted_7 = {
  key: 1,
  class: "col-12 mb-3"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-alle mr-2",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_9 = { class: "title title-with-icon" }
const _hoisted_10 = { class: "col-12 mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-produkte_formulare mr-2",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_12 = { class: "title title-with-icon" }
const _hoisted_13 = {
  key: 2,
  class: "col-12 mb-3"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-vorteile_rund_um_die_uhr mr-2",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_15 = { class: "title title-with-icon" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "break" }, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "invalid-feedback d-block font-16"
}
const _hoisted_18 = {
  key: 3,
  class: "col-12 mb-3"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-alert_fehler mr-2",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_20 = { class: "title title-with-icon" }
const _hoisted_21 = {
  key: 4,
  class: "col-12 mb-3"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-schliesszeiten mr-2",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_23 = { class: "title title-with-icon" }
const _hoisted_24 = { class: "col-12 mb-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-produkte_statistik mr-2",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_26 = { class: "title title-with-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('views.dashboard.title')), 1),
    _createVNode(_component_loading_container, { state: _ctx.state }, {
      default: _withCtx(() => [
        _createElementVNode("ul", _hoisted_2, [
          (_ctx.labelAdminUrl && _ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                _createElementVNode("a", {
                  href: _ctx.sanitizeUrl(_ctx.labelAdminUrl),
                  class: "h1 d-flex align-items-center no-underline"
                }, [
                  _hoisted_5,
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('views.dashboard.editLabels')), 1)
                ], 8, _hoisted_4)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: "/rooms",
                  class: "h1 d-flex align-items-center no-underline"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('views.dashboard.editRoomsAndReservations')), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: "/reservations",
              class: "h1 d-flex flex-wrap align-items-center no-underline"
            }, {
              default: _withCtx(() => [
                _hoisted_11,
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('views.dashboard.reservationsList')), 1)
                ])
              ]),
              _: 1
            })
          ]),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                _createVNode(_component_router_link, {
                  to: "/overbooked",
                  class: "h1 d-flex flex-wrap align-items-start no-underline"
                }, {
                  default: _withCtx(() => [
                    _hoisted_14,
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('views.dashboard.overbooked')), 1),
                      _hoisted_16,
                      (_ctx.overbookedTimeSlots.length > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$tc('common.overbookedTimeSlots', _ctx.overbookedTimeSlots.length )), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                _createVNode(_component_router_link, {
                  to: "/blacklist",
                  class: "h1 d-flex align-items-center no-underline"
                }, {
                  default: _withCtx(() => [
                    _hoisted_19,
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('views.dashboard.blacklist')), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                _createVNode(_component_router_link, {
                  to: "/holiday-list",
                  class: "h1 d-flex align-items-center no-underline"
                }, {
                  default: _withCtx(() => [
                    _hoisted_22,
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('views.dashboard.holidayList')), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", _hoisted_24, [
            _createVNode(_component_router_link, {
              to: "/reports",
              class: "h1 d-flex align-items-center no-underline"
            }, {
              default: _withCtx(() => [
                _hoisted_25,
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('views.dashboard.reports')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["state"])
  ]))
}